// import { Grid, Typography } from "@mui/material";
// import { useEffect } from "react";
// import {
//   Control,
//   FieldErrors,
//   UseFormRegister,
//   UseFormReset,
//   UseFormSetValue,
// } from "react-hook-form";

// interface AssignOrderProps {
//   control?: Control<any>;
//   errors?: FieldErrors;
//   register: UseFormRegister<any>;
//   id: any;
//   reset: UseFormReset<any>;
//   noteId?: string;
//   setValue: UseFormSetValue<any>;
//   onCancel: () => void;
// }

// const AssignOrderDrawer: React.FC<AssignOrderProps> = ({
//   reset,
// }) => {
//   useEffect(() => {
//     return () => reset();
//   }, []);

//   // ==========================================
//   // DATA TO MAP
//   // ==========================================
//   const orderSections = [
//     {
//       title: "Ongoing",
//       orders: [
//         {
//           idLines: ["addressline1", "addressline2", "addressline3", "addressline4"],
//           date: "26-10-2026 & 10:40 AM",
//           location: "Burger St, near Police Station, Fort Nagar, Kannur, 66666",
//         },
//       ],
//     },
//     {
//       title: "Next",
//       orders: [
//         {
//           idLines: ["addressline1", "addressline2", "addressline3", "addressline4"],
//           date: "26-10-2026 & 10:40 AM",
//           location: "Burger St, near Police Station, Fort Nagar, Kannur, 66666",
//         },
//         {
//           idLines: ["addressline1", "addressline2", "addressline3", "addressline4"],
//           date: "26-10-2026 & 10:40 AM",
//           location: "Burger St, near Police Station, Fort Nagar, Kannur, 66666",
//         },
//       ],
//     },
//   ];

  
//   const OrderBox = ({ order }: any) => (
//     <Grid
//       item
//       xs={12}
//       mt={2}
//       p={3}
//       sx={{
//         border: "1px solid #ddd",
//         borderRadius: "16px",
//       }}
//     >
//       <Grid container spacing={2}>
//         {/* Order ID */}
//         <Grid item xs={12} sm={4}>
//           <Typography variant="body2" color="GrayText">
//             Order ID
//           </Typography>
//         </Grid>
//         <Grid item xs={12} sm={8}>
//           {order.idLines.map((line: string, idx: number) => (
//             <Typography key={idx} variant="body2" color="GrayText">
//               : {line}
//             </Typography>
//           ))}
//         </Grid>

//         {/* Date */}
//         <Grid item xs={12} sm={4}>
//           <Typography variant="body2" color="GrayText">
//             Order Date & Time
//           </Typography>
//         </Grid>
//         <Grid item xs={12} sm={8}>
//           <Typography variant="body2" color="GrayText">
//             : {order.date}
//           </Typography>
//         </Grid>

//         {/* Location */}
//         <Grid item xs={12} sm={4}>
//           <Typography variant="body2" color="GrayText">
//             Location
//           </Typography>
//         </Grid>
//         <Grid item xs={12} sm={8}>
//           <Typography variant="body2" color="GrayText">
//             : {order.location}
//           </Typography>
//         </Grid>
//       </Grid>
//     </Grid>
//   );

//   // ==========================================
//   // MAIN RETURN
//   // ==========================================
//   return (
//     <Grid container spacing={2} p={2}>
//       {orderSections.map((section, secIndex) => (
//         <Grid item xs={12} key={secIndex}>
//           {/* Heading */}
//           <Typography variant="body2" fontWeight={400}>
//             {section.title}
//           </Typography>

//           {/* Map each order box */}
//           {section.orders.map((order, orderIndex) => (
//             <OrderBox key={orderIndex} order={order} />
//           ))}
//         </Grid>
//       ))}
//     </Grid>
//   );
// };

// export default AssignOrderDrawer;




import { Grid, Typography, Box } from "@mui/material";
import { useEffect, useState } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
  UseFormSetValue,
} from "react-hook-form";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { callAPI, Method } from "../../../commonFunctions/CommonFunctions"; // ✅ ADD THIS

interface AssignOrderProps {
  control?: Control<any>;
  errors?: FieldErrors;
  register: UseFormRegister<any>;
  id: any;
  reset: UseFormReset<any>;
  noteId?: string;
  setValue: UseFormSetValue<any>;
  onCancel: () => void;
  deliveryPersonId?: string;
}

interface RecentHistory {
  orderId: string;
  status: string;
  customer: string;
  customerAddress: string;
  orderTime: string;
  deliverytime: string;
}

interface ApiResponse {
  status: boolean;
  message: string;
  data: {
    ongoing: any | null;
    next: any[];
    recentHistory: RecentHistory[];
  };
}

const AssignOrderDrawer: React.FC<AssignOrderProps> = ({
  reset,
  deliveryPersonId,
}) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [orderSections, setOrderSections] = useState<any[]>([]);

  useEffect(() => {
    return () => reset();
  }, [reset]);

  const fetchOrdersData = async () => {
    if (!deliveryPersonId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      
      // ✅ FIXED: Use callAPI instead of fetch()
      const response: ApiResponse = await callAPI(
        `pharmacy/DeliveryPerson/DeliveryPerson/${deliveryPersonId}/dashboard`,
        Method.GET
      );

      console.log("✅ AssignOrderDrawer API Response:", response);

      if (response.status && response.data) {
        const history = response.data.recentHistory || [];

        // Transform API data to match your original design structure
        const transformedSections = [
          {
            title: "Ongoing",
            orders: history
              ?.filter((order: RecentHistory) => 
                order.status === "PickedUp" || 
                order.status === "Processing" ||
                order.status === "InProgress"
              )
              ?.map((order: RecentHistory) => ({
                idLines: [order.orderId],
                date: order.orderTime !== "0001-01-01T00:00:00"
                  ? new Date(order.orderTime).toLocaleString('en-IN', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                    })
                  : "Pending",
                location: order.customerAddress,
              })) || [],
          },
          {
            title: "Next",
            orders: history
              ?.filter((order: RecentHistory) => 
                order.status === "Assigned" || 
                order.status === "Pending"
              )
              ?.map((order: RecentHistory) => ({
                idLines: [order.orderId],
                date: order.orderTime !== "0001-01-01T00:00:00"
                  ? new Date(order.orderTime).toLocaleString('en-IN', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                    })
                  : "Pending",
                location: order.customerAddress,
              })) || [],
          },
        ];

        setOrderSections(transformedSections);
      }
    } catch (error) {
      console.error("💥 AssignOrderDrawer Error:", error);
      // Fallback to empty sections
      setOrderSections([
        { title: "Ongoing", orders: [] },
        { title: "Next", orders: [] },
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrdersData();
  }, [deliveryPersonId]);

  const OrderBox = ({ order }: any) => (
    <Grid
      item
      xs={12}
      mt={2}
      p={3}
      sx={{
        border: "1px solid #ddd",
        borderRadius: "16px",
      }}
    >
      <Grid container spacing={2}>
        {/* Order ID */}
        <Grid item xs={12} sm={4}>
          <Typography variant="body2" color="GrayText">
            Order ID
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8}>
          {order.idLines.map((line: string, idx: number) => (
            <Typography key={idx} variant="body2" color="GrayText">
              : {line}
            </Typography>
          ))}
        </Grid>

        {/* Date */}
        <Grid item xs={12} sm={4}>
          <Typography variant="body2" color="GrayText">
            Order Date & Time
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8}>
          <Typography variant="body2" color="GrayText">
            : {order.date}
          </Typography>
        </Grid>

        {/* Location */}
        <Grid item xs={12} sm={4}>
          <Typography variant="body2" color="GrayText">
            Location
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8}>
          <Typography variant="body2" color="GrayText">
            : {order.location}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );

  if (loading) {
    return (
      <Grid container spacing={2} p={2}>
        <Grid item xs={12}>
          <Typography variant="body2" textAlign="center" py={8}>
            Loading orders...
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={2} p={2}>
      {orderSections.map((section, secIndex) => (
        <Grid item xs={12} key={secIndex}>
          {/* Heading */}
          <Typography variant="body2" fontWeight={400}>
            {section.title}
          </Typography>

          {/* Map each order box */}
          {section.orders.map((order: any, orderIndex: number) => (
            <OrderBox key={orderIndex} order={order} />
          ))}
        </Grid>
      ))}

      {/* No Orders Fallback */}
      {orderSections.every((section) => section.orders.length === 0) && (
        <Grid item xs={12}>
          <Box
            sx={{
              p: 8,
              textAlign: "center",
              border: "2px dashed #E0E0E0",
              borderRadius: 3,
              bgcolor: "#F8F9FA",
            }}
          >
            <WSIcons.CiDeliveryTruck 
              style={{ fontSize: 64, color: "#DEE2E6", marginBottom: 16 }} 
            />
            <Typography variant="h4" color="text.secondary" mb={2}>
              No Orders Available
            </Typography>
            <Typography variant="body1" color="text.secondary">
              No ongoing, upcoming, or recent orders found for this technician.
            </Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default AssignOrderDrawer;
